'use es6';

import objectFilter from './objectFilter';
/**
 * @param {Object} object - object to run filters on
 * @param {String|String[]} filters - property name or names to include
 */

const pick = (object, ...filters) => objectFilter(object, true, ...filters);

export default pick;